import { Palette } from '../constants/palette';
export const badgeVariants = {
    default: {
        color: Palette.white,
        backgroundColor: Palette.blue,
    },
    info: {
        backgroundColor: Palette.blue30,
    },
    cancelled: {
        backgroundColor: Palette.gray90,
    },
    required: {
        backgroundColor: Palette.gray96,
    },
    pending: {
        backgroundColor: Palette.orange,
    },
    done: {
        backgroundColor: Palette.mint40,
    },
    warning: {
        backgroundColor: Palette.petalPink,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFkZ2UtdmFyaWFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvYmFkZ2UtdmFyaWFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBRS9DLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBMkI7SUFDbkQsT0FBTyxFQUFFO1FBQ1AsS0FBSyxFQUFFLE9BQU8sQ0FBQyxLQUFLO1FBQ3BCLGVBQWUsRUFBRSxPQUFPLENBQUMsSUFBSTtLQUM5QjtJQUNELElBQUksRUFBRTtRQUNKLGVBQWUsRUFBRSxPQUFPLENBQUMsTUFBTTtLQUNoQztJQUNELFNBQVMsRUFBRTtRQUNULGVBQWUsRUFBRSxPQUFPLENBQUMsTUFBTTtLQUNoQztJQUNELFFBQVEsRUFBRTtRQUNSLGVBQWUsRUFBRSxPQUFPLENBQUMsTUFBTTtLQUNoQztJQUNELE9BQU8sRUFBRTtRQUNQLGVBQWUsRUFBRSxPQUFPLENBQUMsTUFBTTtLQUNoQztJQUNELElBQUksRUFBRTtRQUNKLGVBQWUsRUFBRSxPQUFPLENBQUMsTUFBTTtLQUNoQztJQUNELE9BQU8sRUFBRTtRQUNQLGVBQWUsRUFBRSxPQUFPLENBQUMsU0FBUztLQUNuQztDQUNGLENBQUMifQ==